export default [{
        path: "/controlBines/reportes",
        name: "control-bines-reportes",
        component: () =>
            import ("@/views/pages/controlBines/reportesControl.vue"),
        meta: {
			title: 'i18n:',
            resource: "Control Bines",
            action: "ver-control-bines-reportes",
            pageTitle: "Reportes",
            breadcrumb: [{
                    text: "ControlBines"
                },
                {
                    text: "Reportes",
                    active: true
                }
            ]
        }
    },
    {
        path: "/controlBines/informes/monitoreoMovimientos",
        name: "control-bines-monitoreo-movimientos",
        component: () =>
            import ("@/views/pages/controlBines/monitoreoMovimientos.vue"),
        meta: {
			title: 'i18n:',
            resource: "Control Bines",
            action: "ver-control-bines-monitoreo-movimientos",
         //   title:"i18n:contenido$t",
            //pageTitle: "Monitoreo Movimientos",
            layout: "full"
                /*breadcrumb: [ ver-control-bines-consulta-plan-pesca
                    {
                        text: "ControlBines"
                    },
                    {
                        text: "Monitoreo Movimientos",
                        active: true
                    }
                ]*/
        }
    },

    {
        path: "/controlBines/informes/planPesca",
        name: "control-bines-despacho-pesca",
        component: () =>
            import ("@/views/pages/controlBines/planificacionPesca.vue"),
        meta: {
			title: 'i18n:',
            resource: "Control Bines",
            action: "ver-control-bines-despacho-pesca",
            pageTitle: "Despacho Diario Pesca",
            breadcrumb: [{
                    text: "ControlBines"
                },
                {
                    text: "Despacho pesca",
                    active: true
                }
            ]
        }
    },

    {
        path: "/controlBines/informes/consultaPlanPesca",
        name: "control-bines-consulta-plan-pesca",
        component: () =>
            import ("@/views/pages/controlBines/consultaPlanPescaDiaria.vue"),
        meta: {
			title: 'i18n:',
            resource: "Control Bines",
            action: "ver-control-bines-consulta-plan-pesca",
            pageTitle: "Histórico Planificación Pesca",
            breadcrumb: [{
                    text: "ControlBines"
                },
                {
                    text: "Histórico planificación pesca",
                    active: true
                }
            ]
        }
    },

    {
        path: "/controlBines/informes/desgramos",
        name: "control-bines-desgramos",
        component: () =>
            import ("@/views/pages/controlBines/desgramos.vue"),
        meta: {
			title: 'i18n:',
            resource: "Control Bines",
            action: "ver-control-bines-desgramos",
            pageTitle: "Despacho de gramos",
            breadcrumb: [{
                    text: "ControlBines"
                },
                {
                    text: "Desgramos",
                    active: true
                }
            ]
        }
    },

    {
        path: "/controlBines/informes/estadoGuias",
        name: "control-bines-estado-guias",
        component: () =>
            import ("@/views/pages/controlBines/estadoGuias.vue"),
        meta: {
			title: 'i18n:',
            resource: "Control Bines",
            action: "ver-control-bines-estado-guias",
            pageTitle: "Estado de guías",
            breadcrumb: [{
                    text: "ControlBines"
                },
                {
                    text: "Estado Guías",
                    active: true
                }
            ]
        }
    },
    {
        path: "/controlBines/informes/guiavirtual",
        name: "control-bines-guia-virtual",
        component: () =>
            import ("@/views/pages/controlBines/guiavirtual.vue"),
        meta: {
			title: 'i18n:',
            resource: "Control Bines",
            action: "ver-control-bines-guia-virtual",
            pageTitle: "Guías Virtuales",
            breadcrumb: [{
                    text: "Control Bines"
                },
                {
                    text: "Visualización de Guías Virtuales",
                    active: true
                }
            ]
        }
    },
    {
        path: "/controlBines/transacciones/guiavirtual",
        name: "control-bines-guiavirtual",
        component: () =>
            import ("@/views/pages/controlBines/creacionGuiaVirtual.vue"),
        meta: {
			title: 'i18n:',
            resource: "Control Bines",
            action: "ver-control-bines-guiavirtual",
            pageTitle: "Creación de Guías Virtuales",
            breadcrumb: [{
                    text: "ControlBines"
                },
                {
                    text: "Creación de Guías Virtuales",
                    active: true
                }
            ]
        }
    },
    {
        path: "/controlBines/informes/historicoGuias",
        name: "control-bines-informes-historico-guias",
        component: () => import("@/views/pages/controlBines/historicoGuias.vue"),
        meta: {
			title: 'i18n:',
            resource: "Control Bines",
            action: "ver-control-bines-informes-historico-guias",
            pageTitle: "Histórico Guías",
            breadcrumb: [
                {
                    text: "Control Bines"
                },
                {
                    text: "Histórico Guías",
                    active: true
                }
            ]
        }
    },
    {
        path: "/controlBines/resumen",
        name: "control-bines-resumen",
        component: () =>
            import ("@/views/pages/controlBines/resumenControl.vue"),
        meta: {
			title: 'i18n:',
            resource: "Control Bines",
            action: "ver-control-bines-dashboard",
            pageTitle: "Resumen",
            breadcrumb: [{
                    text: "Control Bines"
                },
                {
                    text: "Resumen",
                    active: true
                }
            ]
        }
    },

];
